import React, { useId, useState } from 'react';
import { Pencil, Save, X } from 'lucide-react';
import InvoiceDateTime from './InvoiceDateTime';
import { actorLabel } from './invoiceDisplay';

export default function InvoiceCaseName({ record, onRename, busy }) {
    const [editing, setEditing] = useState(false);
    const [name, setName] = useState(record.titulo);
    const inputId = useId();
    const valid = Boolean(name.trim()) && name.length <= 200;
    return <div className="esave-case-name">
        <div className="esave-case-name-row">
            <div>
                {editing ? <form className="esave-name-editor" onSubmit={async event => {
                    event.preventDefault();
                    if (!busy && valid && await onRename(record, name.trim())) setEditing(false);
                }}>
                    <label className="esave-label" htmlFor={inputId}>Nombre de la gestión</label>
                    <div className="esave-row-actions">
                        <input id={inputId} className="esave-input" value={name} maxLength={200} required autoFocus disabled={busy}
                            onChange={event => setName(event.target.value)} />
                        <button type="submit" className="esave-button esave-button-primary" disabled={busy || !valid}><Save size={14} aria-hidden="true" />Guardar nombre</button>
                        <button type="button" className="esave-button" disabled={busy} onClick={() => setEditing(false)}><X size={14} aria-hidden="true" />Cancelar</button>
                    </div>
                </form> : <div><p className="esave-caption">Nombre de la gestión</p><strong>{record.titulo}</strong></div>}
                <div className="esave-case-dates" title="Hora de Madrid">
                    <span>Creación: <strong><InvoiceDateTime value={record.created_at} /></strong></span>
                    <span>Última actualización: <strong><InvoiceDateTime value={record.updated_at} /></strong></span>
                    <span>Creador: <strong>{actorLabel(record.created_by)}</strong></span>
                    <span>Último modificador: <strong>{actorLabel(record.updated_by)}</strong></span>
                </div>
            </div>
            {!editing && onRename && <button type="button" className="esave-button" disabled={busy} aria-label={`Editar nombre de ${record.titulo}`}
                onClick={() => { setName(record.titulo); setEditing(true); }}><Pencil size={14} aria-hidden="true" />Editar nombre</button>}
        </div>
    </div>;
}
